import React, { memo, useState, useEffect, FocusEvent, ReactElement } from 'react'
import { InputTypes } from './input.types'

import * as Styled from './Input.styled'

type Props = InputTypes & React.InputHTMLAttributes<HTMLInputElement>

function Input(props: Props): ReactElement {
  const [focus, setFocus] = useState(false)

  useEffect(() => {
    setFocus(focus && !props.value)
  }, [props.value, focus])

  const handleFocus = (event: FocusEvent<HTMLInputElement>) => {
    !event.currentTarget.contains(event.relatedTarget as Node) && setFocus(true)
  }
  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    !event.currentTarget.contains(event.relatedTarget as Node) && setFocus(!!event.target.value)
  }

  return (
    <Styled.InputWrapper>
      <Styled.Label>
        <Styled.Input
          onChange={props.onChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          id={props.id}
          name={props.name}
          type={props.type}
          inputMode={props.inputMode}
          placeholder={props.labelText}
          autoComplete={props.autoComplete}
          autoFocus={props.autoFocus}
          value={props.value}
        />
      </Styled.Label>
    </Styled.InputWrapper>
  )
}

export default memo(Input)
